import { render, staticRenderFns } from "./PrivilegePanel.vue?vue&type=template&id=4ace3909&scoped=true"
import script from "./PrivilegePanel.vue?vue&type=script&lang=js"
export * from "./PrivilegePanel.vue?vue&type=script&lang=js"
import style0 from "./PrivilegePanel.vue?vue&type=style&index=0&id=4ace3909&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace3909",
  null
  
)

export default component.exports